export default "__VITE_ASSET__CAp1iUrv__"